import { pageInfo, exportData, routeUpLoad, template } from './../api';
import { carrier, plant } from '../../../../api'
import { Message } from 'element-ui';
const reshipSku = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    addResp: null,
    editResp: null,
    deleteResp: null,
    initPageObj: null,
    initUpdateObj: null,
    exportObj: null,
    routeUpLoadResp: null,
    templateObj: null,
    selectCarrierObj: null,
    selectWarehouseObj: null,
    selectTransWayObj: null,
    plantObj: []
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = data.obj || [];
    },
    // DELETE_DATA(state, data) {
    //   state.deleteResp = data;
    // },
    EXPORT_DATA(state, data) {
      state.exportObj = data;
    },
    UPLOAD_DATA(state, data) {
      state.routeUpLoadResp = data;
    },
    DOWN_LOAD_TEMPLATE(state, data) {
      state.templateObj = data;
    },
    SELECT_CARRIER_DATA(state, data) {
      state.selectCarrierObj = data.obj || {};
    },
    PLANT(state, data) {
      state.plantObj = data;
    },
  },
  actions: {
    //查询事件
    async pageInfo({ commit, rootGetters }, obj) {
      let resp = await pageInfo(obj);
      if (resp.code === rootGetters.successCode) {
        Message({ showClose: true, message: resp.msg, type: 'success' });
      }
      commit('PAGE_INFO', resp);
    },
    //初始化页面事件
    async initPage({ commit }, obj) {
      let resp = await initPage(obj);
      commit('INIT_PAGE', resp);
    },
    //初始化更新对象事件
    async initUpdate({ commit }, obj) {
      let resp = await initUpdate(obj);
      commit('INIT_UPDATE', resp);
    },
    //新增保存事件
    async saveData({ commit }, obj) {
      let resp = await saveData(obj);
      commit('SAVE_DATA', resp);
    },
    //修改保存事件
    async editData({ commit }, obj) {
      let resp = await editData(obj);
      commit('EDIT_DATA', resp);
    },
    //删除数据事件
    async deleteData({ commit }, obj) {
      let resp = await deleteData(obj);
      commit('DELETE_DATA', resp);
    },
    //导出数据
    async exportData({ commit }, obj) {
      let resp = await exportData(obj);
      commit('EXPORT_DATA', resp);
    },
    //导入数据
    async reshipSkuUpLoad({ commit }, obj) {
      let resp = await routeUpLoad(obj);
      commit('UPLOAD_DATA', resp);
    },
    //下载模板
    async template({ commit }, obj) {
      let resp = await template(obj);
      commit('DOWN_LOAD_TEMPLATE', resp);
    },
    //货运公司
    async selectCarrier({ commit }, obj) {
      let resp = await carrier(obj);
      commit('SELECT_CARRIER_DATA', resp);
    },
    async plant({commit}, obj) {
      let resp = await plant(obj);
      commit('PLANT', resp);
    }
  }
}
export default reshipSku



// WEBPACK FOOTER //
// ./src/page/md/reshipSku/store/reshipSku.store.js